import {
  WebHcpHbsAliquotEntry,
  WebHcpHbsCollectionEntry,
  WebHcpHbsCommonEntry,
  WebHcpHbsInputErrorEntry,
  WebHcpHbsKitDetailsEntry,
  WebHcpHbsLearnMoreEntry,
  WebHcpHbsLogGenerationEntry,
  WebHcpHbsLogPdfEntry,
  WebHcpHbsMultiAliquotEntry,
  WebHcpHbsPatientOverviewEntry,
  WebHcpHbsPatientSamplesEntry,
  WebHcpHbsProcessingEntry,
  WebHcpHbsSampleAliquotLearnMoreEntry,
  WebHcpHbsSampleDetailsEntry,
  WebHcpHbsSampleListEntry,
  WebHcpHbsSampleMultiAliquotLearnMoreEntry,
  WebHcpHbsSelectSamplesEntry,
  WebHcpHbsSessionEntry,
  WebHcpHbsShippingEntry,
  WebHcpHbsVisitSampleDetailsEntry,
} from '@csp/csp-web-content-definitions';
import { StaticContentService } from '../../../common/service/StaticContentService';

const getAliquotTexts = (): WebHcpHbsAliquotEntry => StaticContentService.getGenericEntry('webHcpHbsAliquot');
const getCollectionTexts = (): WebHcpHbsCollectionEntry => StaticContentService.getGenericEntry('webHcpHbsCollection');
const getCommonTexts = (): WebHcpHbsCommonEntry => StaticContentService.getGenericEntry('webHcpHbsCommon');
const getInputErrorTexts = (): WebHcpHbsInputErrorEntry => StaticContentService.getGenericEntry('webHcpHbsInputError');
const getKitDetailsTexts = (): WebHcpHbsKitDetailsEntry => StaticContentService.getGenericEntry('webHcpHbsKitDetails');
const getLearnMoreTexts = (): WebHcpHbsLearnMoreEntry => StaticContentService.getGenericEntry('webHcpHbsLearnMore');
const getLogGenerationTexts = (): WebHcpHbsLogGenerationEntry =>
  StaticContentService.getGenericEntry('webHcpHbsLogGeneration');
const getLogPdfTexts = (): WebHcpHbsLogPdfEntry => StaticContentService.getGenericEntry('webHcpHbsLogPdf');
const getMultiAliquotTexts = (): WebHcpHbsMultiAliquotEntry =>
  StaticContentService.getGenericEntry('webHcpHbsMultiAliquot');
const getPatientOverviewTexts = (): WebHcpHbsPatientOverviewEntry =>
  StaticContentService.getGenericEntry('webHcpHbsPatientOverview');
const getPatientSamplesTexts = (): WebHcpHbsPatientSamplesEntry =>
  StaticContentService.getGenericEntry('webHcpHbsPatientSamples');
const getProcessingTexts = (): WebHcpHbsProcessingEntry => StaticContentService.getGenericEntry('webHcpHbsProcessing');
const getSampleAliquotLearnMoreTexts = (): WebHcpHbsSampleAliquotLearnMoreEntry =>
  StaticContentService.getGenericEntry('webHcpHbsSampleAliquotLearnMore');
const getSampleMultiAliquotLearnMoreTexts = (): WebHcpHbsSampleMultiAliquotLearnMoreEntry =>
  StaticContentService.getGenericEntry('webHcpHbsSampleMultiAliquotLearnMore');
const getSampleDetailsTexts = (): WebHcpHbsSampleDetailsEntry =>
  StaticContentService.getGenericEntry('webHcpHbsSampleDetails');
const getSampleListTexts = (): WebHcpHbsSampleListEntry => StaticContentService.getGenericEntry('webHcpHbsSampleList');
const getSelectSamplesTexts = (): WebHcpHbsSelectSamplesEntry =>
  StaticContentService.getGenericEntry('webHcpHbsSelectSamples');
const getSessionTexts = (): WebHcpHbsSessionEntry => StaticContentService.getGenericEntry('webHcpHbsSession');
const getShippingTexts = (): WebHcpHbsShippingEntry => StaticContentService.getGenericEntry('webHcpHbsShipping');
const getVisitSampleDetailsTexts = (): WebHcpHbsVisitSampleDetailsEntry =>
  StaticContentService.getGenericEntry('webHcpHbsVisitSampleDetails');

export const BioSampleContentService = {
  getAliquotTexts,
  getCollectionTexts,
  getCommonTexts,
  getInputErrorTexts,
  getKitDetailsTexts,
  getLearnMoreTexts,
  getLogGenerationTexts,
  getLogPdfTexts,
  getMultiAliquotTexts,
  getPatientOverviewTexts,
  getPatientSamplesTexts,
  getProcessingTexts,
  getSampleAliquotLearnMoreTexts,
  getSampleMultiAliquotLearnMoreTexts,
  getSampleDetailsTexts,
  getSampleListTexts,
  getSelectSamplesTexts,
  getSessionTexts,
  getShippingTexts,
  getVisitSampleDetailsTexts,
};
